import React, { useEffect, useState } from "react";
import "./Loginpage.css";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../Store";
import { loginwithapi } from "./Loginpageslice";

export default function Loginpage() {

    const [passwordShown, setPasswordShown] = useState(false);
    const [isSubmitting, setisSubmitting] = useState(false);
    const Navigate = useNavigate()   

    const Userlogindata: any = useSelector((state: RootState) => state.Loginapi.Userlogindata)
    const dispatch: AppDispatch = useDispatch()

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [Userlogindata])

    const validationSchema = Yup.object().shape({
        email: Yup.string().required('Email is required').email('Email is invalid'),
        password: Yup.string()
            .required('Password is required')
            .min(6, 'Password must be at least 6 characters')
            .max(40, 'Password must not exceed 40 characters')
        // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/, "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"),
    });

    const login = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema,
        onSubmit: (data: any) => {
            setisSubmitting(true)
            return new Promise((resolve) => {
                setTimeout(() => {
                    setisSubmitting(false);
                    resolve(undefined);
                    dispatch(loginwithapi(data)).then(() => {
                        Navigate("/accountsettingpage")
                    })
                }, 3000)
            })
        },
    });



    return (
        <>
            {/* Login page start */}

            <div className="booksmart_login_page">
                <div className="row m-0 align-items-center">
                    <div className="col-md-6 p-0">
                        <div className="booksmart_login_page_logo">
                            <img src="/assets/images/booksmart-logo-login.png" alt="" />
                        </div>
                    </div>
                    <div className="col-md-6 p-0">
                        <div className="booksmart_login_page_form">
                            <img src="/assets/images/login-form-bg.jpeg" alt="login-form-bg" />

                            <div className="booksmart_login_page_form_modal">
                                <h3 className="sign_heading">Sign In</h3>
                                <p className="welcome_text">
                                    Welcome to Booksmart, please put your login credentials below to start using the website.
                                </p>
                                <form onSubmit={login.handleSubmit}>
                                    <div className="login_email_fill">
                                        <label htmlFor="email"><span>Email Address</span></label>
                                        <input id="email" type="email"
                                            name="email"
                                            className={
                                                'form-control' +
                                                (login.errors.email && login.touched.email ? ' is-invalid' : '')
                                            }
                                            onChange={login.handleChange}
                                            value={login.values.email} placeholder="E-Mail" />
                                        <div className="invalid-feedback" >
                                            {login.errors.email && login.touched.email
                                                ? login.errors.email
                                                : null}
                                        </div>
                                    </div>
                                    <div className="login_password_fill">
                                        <label htmlFor="password"><span>Password</span></label>
                                        <input type={passwordShown ? "text" : "password"}
                                            name="password"
                                            className={
                                                'form-control' +
                                                (login.errors.password && login.touched.password
                                                    ? ' is-invalid'
                                                    : '')
                                            }
                                            onChange={login.handleChange}
                                            value={login.values.password} placeholder="Password" />
                                        <img src={`${passwordShown ? "/assets/images/eye-slash.png" : "/assets/images/eye.png"}`} onClick={togglePasswordVisiblity} alt="Eye" className="eye_icon" />
                                        <div className="invalid-feedback">
                                            {login.errors.password && login.touched.password
                                                ? login.errors.password
                                                : null}
                                        </div>
                                    </div>
                                    <div className="forgot_password">
                                        <Link to="/loginpage" className="Forgot My Password">Forgot My Password</Link>
                                    </div>
                                    <button type="submit" disabled={isSubmitting} className="login_submit">  {isSubmitting && (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    )} Sign In</button>
                                    <div className="signup_part">
                                        <p>No account yet? |
                                            <Link to="/loginpage"> Create an account</Link></p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Login page over */}
        </>
    )
}